import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/select/style";
import _Select from "antd/lib/select";
import "antd/lib/date-picker/style";
import _DatePicker from "antd/lib/date-picker"; /*@客户-日流量*/
import React from 'react';
import { connect } from 'dva';
import * as echarts from 'echarts';
import moment from 'moment';
import { chartColor } from "../../../../utils/commonConsts";
import { injectIntl } from 'react-intl';
import noWan from "../../../../assets/img/noWan.png";
var RangePicker = _DatePicker.RangePicker;
var Option = _Select.Option;
var HistoryFlowModal = /*#__PURE__*/function (_React$Component) {
  _inherits(HistoryFlowModal, _React$Component);
  function HistoryFlowModal(props) {
    var _this;
    _classCallCheck(this, HistoryFlowModal);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(HistoryFlowModal).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelectTopoName", function (value) {
      _this.setState({
        link_id: value
      }, function () {
        this.props.dispatch({
          type: "ci0401Info/getHistoryRate",
          payload: {
            link_id: this.state.link_id || this.props.link_id,
            start_time: this.state.start_time,
            end_time: this.state.end_time
          }
        });
        this.forceUpdate();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelectDate", function (dates) {
      _this.setState({
        start_time: dates[0].format("YYYY-MM-DD"),
        end_time: dates[1].format("YYYY-MM-DD")
      }, function () {
        this.props.dispatch({
          type: "ci0401Info/getHistoryRate",
          payload: {
            link_id: this.state.link_id || this.props.link_id,
            start_time: this.state.start_time,
            end_time: this.state.end_time
          }
        });
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disabledDate", function (current) {
      return current > moment().endOf('day');
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderChart", function (el, dataSource) {
      var dateList = dataSource.map(function (item) {
        return item.date;
      });
      var originRate = dataSource.map(function (item) {
        return (item.origin / 1024 / 1024).toFixed(2);
      });
      var compressedPercent = dataSource.map(function (item) {
        return item.rate === 0 ? 0 : parseInt(100 * (item.rate - item.drate) / item.rate, 10).toFixed(2);
      });
      var tunnelRate = dataSource.map(function (item) {
        if (_this.props.deduplication === "ON") {
          var dedupPercent = item.dedup_raw === 0 ? 0 : parseInt(100 * (item.dedup_raw - item.dedup) / item.dedup_raw, 10).toFixed(2);
          var _compressedPercent = item.rate === 0 ? 0 : parseInt(100 * (item.rate - item.drate) / item.rate, 10).toFixed(2);
          return ((item.origin / 1024 / 1024).toFixed(2) * (1 - dedupPercent / 100) * (1 - _compressedPercent / 100)).toFixed(2);
        } else {
          var _compressedPercent2 = item.rate === 0 ? 0 : parseInt(100 * (item.rate - item.drate) / item.rate, 10).toFixed(2);
          return (item.origin / 1024 / 1024 * (1 - _compressedPercent2 / 100)).toFixed(2);
        }
      });
      var dedupSeries = [];
      if (_this.props.deduplication === "ON") {
        var dedupPercent = dataSource.map(function (item) {
          return item.dedup_raw === 0 ? 0 : parseInt(100 * (item.dedup_raw - item.dedup) / item.dedup_raw, 10).toFixed(2);
        });
        dedupSeries = [{
          name: "Weight removal rate (%)",
          type: 'line',
          yAxisIndex: 1,
          lineStyle: {
            normal: {
              type: 'dashed'
            }
          },
          data: dedupPercent,
          smoothMonotone: "x",
          smooth: true
        }];
      }
      var compressSeries = [{
        name: "Raw traffic",
        type: 'line',
        yAxisIndex: 0,
        lineStyle: {
          normal: {
            type: 'solid'
          }
        },
        data: originRate,
        smoothMonotone: "x",
        smooth: true
      }, {
        name: "Tunnel flow",
        type: 'line',
        yAxisIndex: 0,
        lineStyle: {
          normal: {
            type: 'solid'
          }
        },
        data: tunnelRate,
        smoothMonotone: "x",
        smooth: true
      }, {
        name: "Compression rate (%)",
        type: 'line',
        yAxisIndex: 1,
        lineStyle: {
          normal: {
            type: 'dashed'
          }
        },
        data: compressedPercent,
        smoothMonotone: "x",
        smooth: true
      }];
      var series = compressSeries.concat(dedupSeries);
      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: "#333",
          extraCssText: 'box-shadow: 0 2px 2px 0 rgba(24,24,24,0.60);border-radius: 2px 2px 0 0 0 2px 2px;',
          formatter: function formatter(data) {
            var res = '';
            for (var i = 0; i < data.length; i++) {
              res += '<tr><td><span style="font-size:32px;color:' + data[i].color + '">&middot;</span>' + data[i].seriesName + '</td><td>' + data[i].data + '<td/><td>' + data[i].axisValue + '</td></tr>';
            }
            return '<div class="line-tooltip"><table class="line-tooltip-table" style="border-bottom: none">' + res + '<table/></div>';
          }
        },
        grid: {
          left: '10%',
          right: '5%',
          bottom: '15%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dateList,
          min: _this.state.start_tm,
          max: _this.state.end_tm,
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,0.45)"
            }
          }
        },
        legend: {
          left: "center",
          bottom: 0,
          icon: "circle"
        },
        yAxis: [{
          type: 'value',
          name: "Traffic (MB)",
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        }, {
          type: 'value',
          name: "%",
          max: 100,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        }],
        series: series,
        color: chartColor
      };
      el.clear();
      el.setOption(option);
    });
    _this.state = {
      link_id: "",
      start_time: moment().subtract(7, "days").format("YYYY-MM-DD"),
      end_time: moment().format("YYYY-MM-DD")
    };
    return _this;
  }
  _createClass(HistoryFlowModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var el;
      if (document.getElementById("history-flow-chart")) {
        el = echarts.init(document.getElementById("history-flow-chart"));
        this.renderChart(el, this.props.ci0401Info.modalDataSource);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_Modal, {
        maskClosable: false,
        visible: this.props.ifModalShow,
        title: "Historical traffic",
        onCancel: this.props.cancel,
        width: 800,
        footer: null,
        destroyOnClose: true
      }, /*#__PURE__*/React.createElement(_Select, {
        style: {
          width: 250,
          marginRight: 8
        },
        placeholder: "Please select a link name",
        onChange: this.handleSelectTopoName,
        defaultValue: this.props.link_id
      }, this.props.ci0401Info.dataSource.map(function (item) {
        return /*#__PURE__*/React.createElement(Option, {
          key: item.id,
          value: item.id
        }, item.name);
      })), /*#__PURE__*/React.createElement(RangePicker, {
        onChange: this.handleSelectDate,
        disabledDate: this.disabledDate,
        defaultValue: [moment(this.state.start_time), moment(this.state.end_time)]
      }), this.props.ci0401Info.modalDataSource.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        id: "history-flow-chart",
        style: {
          height: 450,
          marginTop: 24
        }
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: noWan,
        alt: "",
        style: {
          marginTop: 60
        }
      })));
    }
  }]);
  return HistoryFlowModal;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0401Info = _ref.ci0401Info;
  return {
    ci0401Info: ci0401Info
  };
}
export default connect(mapDispatchToProps)(injectIntl(HistoryFlowModal));